/* ═══════════════════════════════════════════════════════════════
   archive — the ONE filter every archivable list uses, so a page can add
   an "Archive" action without hand-rolling its own `!row.archivedAt`
   check. Pairs with each service's `setArchived(id, archived, userName)`
   (ProjectService, OrgService, TaskService, InvoiceService,
   SpecMasterService, FormaService, ProjectSpecService, ModuleService).
   ═══════════════════════════════════════════════════════════════ */

/** True when the row carries a live archive timestamp. */
export function isArchived(row: { archivedAt?: string | null }): boolean {
  return !!row?.archivedAt;
}

/** Filter a list down to active rows, unless the caller is showing the
 *  archive (in which case every row — active and archived — passes
 *  through unchanged, so "Show archived" means "show everything"). */
export function activeOnly<T extends { archivedAt?: string | null }>(
  rows: T[],
  showArchived: boolean
): T[] {
  if (showArchived) return rows;
  return rows.filter((r) => !isArchived(r));
}
